export const buildNumber = 'master-1371';
